import {
  createFrontendModule,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  configApiRef,
  type OAuthApi,
  type ProfileInfoApi,
  type BackstageIdentityApi,
  type SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';

/** Auth API for the generic `oidc` sign-in provider, which Backstage does not ship one for. */
export const oidcAuthApiRef = createApiRef<
  OAuthApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.oidc',
});

const oidcAuthApi = ApiBlueprint.make({
  name: 'oidc-auth',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: oidcAuthApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
          configApi: configApiRef,
        },
        factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
          OAuth2.create({
            configApi,
            discoveryApi,
            oauthRequestApi,
            // id must match the provider key under auth.providers in the
            // backend config; /api/auth/oidc/* is mounted on it.
            provider: {
              id: 'oidc',
              title: 'GOALS SSO',
              icon: () => null,
            },
            environment: configApi.getOptionalString('auth.environment'),
            defaultScopes: ['openid', 'profile', 'email'],
          }),
      }),
    ),
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcAuthApi],
});
